export default {"src":"/_next/static/media/survey.1e5e0be7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};